import { Box, Grid, Skeleton, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import CustomTooltip from 'src/components/visibility/components/CustomTooltip';
import { DASH } from './format';

export type KpiCardItem = {
  key: string;
  title: string;
  definition: string;
  value: string;
};

/**
 * Row of 4 KPI cards (maquette « Info_card_group »): title + info tooltip, value, no evolution.
 * `error`: the request failed, values shown as « — » rather than zeros.
 */
export default function KpiCards({ items, loading, error }: { items: KpiCardItem[]; loading?: boolean; error?: boolean }) {
  return (
    <Grid container spacing={1.5} data-testid="campaign-leaks-kpis">
      {items.map((item) => (
        <Grid item key={item.key} xs={6} md={3}>
          {loading ? (
            <Skeleton variant="rounded" width="100%" height={80} animation="wave" sx={{ borderRadius: '12px' }} />
          ) : (
            <Stack
              data-testid={`kpi-${item.key}`}
              sx={{
                height: 80,
                px: '16px',
                py: '12px',
                gap: '8px',
                justifyContent: 'center',
                bgcolor: 'background.paper',
                border: '1px solid #DFE3E8',
                borderRadius: '12px',
              }}
            >
              <Stack direction="row" spacing="6px" alignItems="center">
                <Typography sx={{ color: '#637381', fontSize: '12px', fontWeight: 400, lineHeight: '12px', whiteSpace: 'nowrap' }}>
                  {item.title}
                </Typography>
                <CustomTooltip title={item.definition} placement="top">
                  <Box component="span" sx={{ display: 'inline-flex', cursor: 'help' }}>
                    <Iconify icon="eva:info-outline" width={12} height={12} sx={{ color: 'text.disabled' }} />
                  </Box>
                </CustomTooltip>
              </Stack>
              <Typography sx={{ color: '#1C252E', fontSize: '20px', fontWeight: 700, lineHeight: '20px' }}>
                {error ? DASH : item.value}
              </Typography>
            </Stack>
          )}
        </Grid>
      ))}
    </Grid>
  );
}
